import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
  loading: false,
  userGroupData: {},
  error: "",
  success: false,
  status: "",
};

const createUserGroupCall = createAsyncThunk(
  "create/user-group",
  async (data) => {
    try {
      const result = await axios.post(
        "https://apac.api.capillarytech.com/mobile/v2/api/create/userGroup",
        data
      );

      return result?.data;
    } catch (err) {
      console.log(err);
    }
  }
);

const createUserGroupSlice = createSlice({
  name: "user-group",
  initialState,
  reducers: {
    reset: (state, payload) => {
      state.loading = false;
      state.success = false;
      state.error = "";
      state.userGroupData = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createUserGroupCall.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createUserGroupCall.fulfilled, (state, action) => {
      state.loading = false;
      state.userGroupData = action.payload.entity;
      state.success = action.payload?.warnings?.length === 0 ? true : false;
      state.error =
        action.payload?.warnings?.length > 0 ? action.payload?.warnings[0] : "";
    });
    builder.addCase(createUserGroupCall.rejected, (state, action) => {
      state.loading = false;
      state.userGroupData = {};
      state.error = action.error.message;
      state.success = false;
    });
  },
});

export default createUserGroupSlice.reducer;
export const { reset } = createUserGroupSlice.actions;
export { createUserGroupCall };
